<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getUrlTicketAndSave, getAndSaveDistrictIdFromUrl, getParamFromUrl, handleClean } from '@/utils/common'
import { defaultCityInfo } from '@/constant/index'
import { mapMutations, mapState } from 'vuex'
import aplus from './utils/aplus'

export default {
  name: 'app',

  data() {
    return {
      curRouterPath: ''
    }
  },
  async created() {
    let unionType = getUrlTicketAndSave()
    // 地址栏有登录token 代表从登录页返回
    if (unionType) {
      // 用户类型 1：个人 2：法人
      const zjzwIsUser = window.zjzwIsUser
      if (zjzwIsUser === '2' || unionType === 'ticket') {
        await this.$store.dispatch('user/getUserInfoTicket')
      } else if (zjzwIsUser === '1' || unionType === 'token') {
        await this.$store.dispatch('user/getUserInfoToken')
      }

      if (!sessionStorage.getItem('userInfoGetFlag')) {
        sessionStorage.setItem('userInfoGetFlag', true)
        location.reload()
        return
      }
      const gotoUrl = localStorage.getItem('gotoUrl')
      if (gotoUrl) {
        // 清空地址栏登录信息(必须) 并重定向到登录之前到访问页面路由
        const url = `${window.location.origin}${window.location.pathname}`
        history.replaceState({}, '', url)
        this.$router.push(gotoUrl)
      }
    }

    this.initCityInfo()
    aplus({ ...this.userInfo, userType: this.userType })
    const userTypeFromURL = getParamFromUrl('userType')
    if (userTypeFromURL) {
      this.$store.commit('user/SET_USER_TYPE_FROM_URL', userTypeFromURL)
    }
    this.setApplyPlatformFlag()
    this.setDefaultProductNameForSearch()
    setTimeout(() => {
      const userlogin = window.zjzwIslogin()
      console.log('userlogin-----', userlogin)
      if (!userlogin) {
        handleClean()
      }
    }, 500)
  },
  watch: {
    $route(to, from) {
      this.curRouterPath = to.path
      // zscq 布局不限制 body html 最小宽度
      if (to.name.includes('zscq')) {
        document.body.style.minWidth = 'unset'
        document.documentElement.style.minWidth = 'unset'
        // document.querySelector('.zjzw-foot').style.display = 'none'
      }

      aplus({ ...this.userInfo, userType: this.userType })
    }
  },
  computed: {
    isShowFooter() {
      if (this.$route.name === '500') return false
      return !(this.curRouterPath || this.$route.path).match(/(zscq)/)
    },
    // 老年版
    uiStyle() {
      return this.$store.state.user.uiStyle
    },
    ...mapState('user', ['userInfo', 'userType'])
  },
  methods: {
    setApplyPlatformFlag() {
      if (getParamFromUrl('applyPlatform')) {
        sessionStorage.setItem('applyPlatform', getParamFromUrl('applyPlatform') || 0)
      }
    },
    setDefaultProductNameForSearch() {
      if (getParamFromUrl('productName')) {
        sessionStorage.setItem('productName', decodeURI(getParamFromUrl('productName') || ''))
      }
    },
    async initCityInfo() {
      let areaId = await getAndSaveDistrictIdFromUrl()
      if (!areaId) {
        this.SET_DEFAULT_CITY_INFO(defaultCityInfo)
      } else {
        this.$root.$emit('area-change')
      }
    },
    ...mapMutations('user', ['SET_DEFAULT_CITY_INFO'])
  }
}
</script>

<style lang="scss">
body {
  padding: 0;
  margin: 0;
  // user-select: none;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Microsoft YaHei;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-pager li {
  &:hover {
    background-color: rgba(41, 84, 208, 0.1) !important;
  }
}
</style>
